import React from "react";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import classes from "./PlannerOverviewSkeletonLoader.scss";

const PlannerOverviewSkeletonLoader = () => {
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.section} style={{ paddingTop: "0px" }}>
          <div className={classes.sectionHeader}>
            <SkeletonLoader width="65%" height="20px" variant="rounded" />
          </div>

          <div className={classes.sectionContent}>
            <div className={classes.fieldItem}>
              <SkeletonLoader width="50%" height="20px" variant="rounded" />
              <SkeletonLoader width="30%" height="20px" variant="rounded" />
            </div>
          </div>
        </div>
        <div className={classes.section}>
          <div className={classes.sectionHeader}>
            <SkeletonLoader width="65%" height="20px" variant="rounded" />
          </div>

          <div className={classes.sectionContent}>
            <div className={classes.fieldItem}>
              <SkeletonLoader width="50%" height="20px" variant="rounded" />
              <SkeletonLoader width="30%" height="20px" variant="rounded" />
              <SkeletonLoader width="30%" height="20px" variant="rounded" />
            </div>
          </div>
        </div>
        <div className={classes.section}>
          <div className={classes.sectionHeader}>
            <SkeletonLoader width="65%" height="20px" variant="rounded" />
          </div>

          <div className={classes.sectionContent}>
            <div className={classes.fieldItem}>
              <SkeletonLoader width="50%" height="20px" variant="rounded" />
              <SkeletonLoader width="30%" height="20px" variant="rounded" />
            </div>
          </div>
        </div>
        <div className={classes.section}>
          <div className={classes.sectionHeader}>
            <SkeletonLoader width="65%" height="20px" variant="rounded" />
          </div>

          <div className={classes.sectionContent}>
            <div className={classes.fieldItem}>
              <SkeletonLoader width="50%" height="20px" variant="rounded" />
              <SkeletonLoader width="30%" height="20px" variant="rounded" />
              <SkeletonLoader width="30%" height="20px" variant="rounded" />
            </div>
          </div>
        </div>
        <div className={classes.section}>
          <div className={classes.sectionHeader}>
            <SkeletonLoader width="65%" height="20px" variant="rounded" />
          </div>

          <div className={classes.sectionContent}>
            <div className={classes.fieldItem}>
              <SkeletonLoader width="50%" height="20px" variant="rounded" />
              <SkeletonLoader width="30%" height="20px" variant="rounded" />
            </div>
            <div className={classes.fieldItem}>
              <SkeletonLoader width="50%" height="20px" variant="rounded" />
              <SkeletonLoader width="30%" height="20px" variant="rounded" />
            </div>

            <div className={classes.fieldItem}>
              <SkeletonLoader width="50%" height="20px" variant="rounded" />
              <SkeletonLoader width="30%" height="20px" variant="rounded" />
              <SkeletonLoader width="30%" height="20px" variant="rounded" />
            </div>
          </div>
        </div>
        <div className={classes.section}>
          <div className={classes.sectionHeader}>
            <SkeletonLoader width="65%" height="20px" variant="rounded" />
          </div>

          <div className={classes.sectionContent}>
            <div className={classes.fieldItem}>
              <SkeletonLoader width="50%" height="20px" variant="rounded" />
              <SkeletonLoader width="30%" height="20px" variant="rounded" />
              <SkeletonLoader width="30%" height="20px" variant="rounded" />
            </div>
          </div>
        </div>
        <div className={classes.section}>
          <div className={classes.sectionHeader}>
            <SkeletonLoader width="65%" height="20px" variant="rounded" />
          </div>

          <div className={classes.sectionContent}>
            <div className={classes.fieldItem}>
              <SkeletonLoader width="50%" height="20px" variant="rounded" />
              <SkeletonLoader width="30%" height="20px" variant="rounded" />
            </div>
            <div className={classes.fieldItem}>
              <SkeletonLoader width="50%" height="20px" variant="rounded" />
              <SkeletonLoader width="30%" height="20px" variant="rounded" />
            </div>

            <div className={classes.fieldItem}>
              <SkeletonLoader width="50%" height="20px" variant="rounded" />
              <SkeletonLoader width="30%" height="20px" variant="rounded" />
              <SkeletonLoader width="30%" height="20px" variant="rounded" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlannerOverviewSkeletonLoader;
